// landlord = owner in Rexpm
export type Role = "vendor" | "agent" | "agent_manager" | "tenant" | "landlord";

export const ROLES: Role[] = [
  "vendor",
  "agent",
  "agent_manager",
  "tenant",
  "landlord",
];

/**
 * Maps an internal {@link Role} to the role name used by the RexPM API.
 * RexPM represents the landlord role as "owner"; every other role is unchanged.
 */
export function toApiRole(role: Role): string {
  return role === "landlord" ? "owner" : role;
}
